import { ChangeEvent, forwardRef, useState } from 'react';
import cx from 'clsx';
import { v4 as uuidv4 } from 'uuid';

export type SquareCheckBoxProps = {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  name?: string;
  disabled?: boolean;
  checked?: boolean;
  showError?: boolean;
};

export const SquareCheckBox = forwardRef<HTMLInputElement, SquareCheckBoxProps>(
  (props, ref) => {
    const [checked, setChecked] = useState(props.checked ?? false);
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      setChecked(event.target.checked);
      if (props.onChange && !props.disabled) {
        props.onChange(event);
      }
    };
    const id = uuidv4();

    const checkboxClasses = {
      base: 'border-ui-border bg-ui-form-background peer inline-flex h-10 w-10 shrink-0 appearance-none items-center justify-center rounded border border-solid',
      afterElement:
        "after:border-text-body after:hidden after:h-4 after:w-6 after:-translate-y-1 after:rotate-[-50deg] after:border-b-[3px] after:border-l-[3px] after:content-['']",
      states:
        'checked:after:block disabled:cursor-not-allowed disabled:opacity-50 focus:outline outline-ui-border outline-2 outline-offset-0',
    };

    return (
      <input
        disabled={props.disabled}
        id={props.id ?? id}
        type="checkbox"
        className={cx(
          checkboxClasses.base,
          checkboxClasses.afterElement,
          checkboxClasses.states,
        )}
        checked={checked}
        name={props.name}
        ref={ref}
        onChange={handleChange}
      />
    );
  },
);

SquareCheckBox.displayName = 'SquareCheckbox';
